import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerJobScreenComponent } from './customer/customer-job-screen.component';
import { SupplierJobScreenComponent } from './supplier/supplier-job-screen.component';
import { VMEJobScreenComponent } from './vme/vme-job-screen.component';
import { VMEJobScreenDatesPricesComponent } from './vme/vme-job-screen-dates-prices/vme-job-screen-dates-prices.component';
import { VmeChangeJobDetailsDialogComponent } from './vme/vme-change-job-details-dialog/vme-change-job-details-dialog.component';
import { JobScreenHistoryComponent } from './common/job-screen-history/job-screen-history.component';
import { VMEJobScreenSupplierInfoComponent } from './vme/vme-job-screen-supplier-info/vme-job-screen-supplier-info.component';
import { JobScreenContainerComponent } from './job-screen-container.component';
import { JobScreenModule } from '../../modules/lazy-loaded/job-screen.module';
import { VMEJobScreenIncidentsComponent } from './vme/vme-job-screen-incidents/vme-job-screen-incidents.component';
import { TabScrollerComponent } from './common/tab-scroller/tab-scroller.component';
import { VmeAdditionalCostsComponent } from './vme/vme-additional-costs/vme-additional-costs.component';
import { JobScreenOrdersComponent } from './common/job-screen-orders/job-screen-orders.component';
import { PostcodeMapsModule } from '../../modules/lazy-loaded/postcode-maps.module';
import { VMEJobScreenTasksServiceTypeComponent } from './vme/vme-job-screen-tasks-service-type/vme-job-screen-tasks-service-type.component';
import { JobScreenTasksComponent } from './common/job-screen-tasks/job-screen-tasks.component';
import { VMEJobScreenRecognitionComponent } from './vme/vme-job-screen-recognition/vme-job-screen-recognition.component';
import { JobScreenChecklistComponent } from './common/job-screen-checklist/job-screen-checklist.component';
import { JobScreenModelPinComponent } from './common/job-screen-model-pin/job-screen-model-pin.component';
import { JobScreenReleaseCodeComponent } from './common/job-screen-release-code/job-screen-release-code.component';
import { JobScreenDriverDetailsComponent } from './common/job-screen-driver-details/job-screen-driver-details.component';
import { JobScreenDriverNotesComponent } from './common/job-screen-driver-notes/job-screen-driver-notes.component';
import { JobScreenSiteOpeningComponent } from './common/job-screen-site-opening/job-screen-site-opening.component';
import { JobScreenContactPeopleComponent } from './common/job-screen-contact-people/job-screen-contact-people.component';
import { JobScreenFuelLevelsComponent } from './common/job-screen-fuel-levels/job-screen-fuel-levels.component';
import { JobScreenOdometerReadingsComponent } from './common/job-screen-odometer-readings/job-screen-odometer-readings.component';
import { JobScreenVehicleInformationComponent } from './common/job-screen-vehicle-information/job-screen-vehicle-information.component';
import { JobScreenImageGalleryComponent } from './common/job-screen-image-gallery/job-screen-image-gallery.component';
import { JobScreenDriverMessagesComponent } from './common/job-screen-driver-messages/job-screen-driver-messages.component';
import { JobScreenLateStatusComponent } from './common/job-screen-late-status/job-screen-late-status.component';
import { JobScreenDriverPerformanceComponent } from './common/job-screen-driver-performance/job-screen-driver-performance.component';
import { AutoCompleteModule, ButtonModule, DialogModule } from 'primeng';
import { ChecklistCategoryItemModule } from '../checklist-category-item/checklist-category-item.module';
import { JobScreenOrderTasksComponent } from './common/job-screen-job-details/job-screen-order-tasks.component';
import { JobScreenDelayFailuresDialogComponent } from './common/job-screen-delay-failures/job-screen-delay-failures-dialog.component';
import { EditTaskWindowsDialogComponent } from '../edit-task/edit-task-windows-dialog.component';
import { JobScreenEditVehicleDialog } from './common/job-screen-edit-vehicle-dialog/job-screen-edit-vehicle-dialog.component';
import { VmeCancelOrderDialogComponent } from './common/job-screen-orders/vme-cancel-order-dialog.component';
import { JobScreenInspectionContactsComponent } from './common/job-screen-inspection-contacts/job-screen-inspection-contacts.component';
import { JobScreenInspectionHandoverComponent } from './common/job-screen-inspection-handover/job-screen-inspection-handover.component';
import { What3wordsComponent } from '../logos/what3words/what3words.component';
import { VmeEditOrderDialogComponent } from './common/job-screen-orders/vme-edit-order-dialog/vme-edit-order-dialog.component';
import { EditContactDetailsDialogComponent } from './common/job-screen-driver-notes/edit-driver-notes-dialog/edit-contact-details-dialog.component';
import { JobScreenCarryOverComponent } from './common/job-screen-carry-over/job-screen-carry-over.component';
import { TaskSequencingEditorComponent } from '../task-sequencing-editor/task-sequencing-editor.component';
import { SupplierJobScreenTasksComponent } from './supplier/supplier-job-screen-tasks/supplier-job-screen-tasks.component';
import { SupplierJobScreenRejectJobComponent } from './supplier/supplier-job-screen-reject-job/supplier-job-screen-reject-job.component';
import { SupplierJobScreenSupplierInfoComponent } from './supplier/supplier-job-screen-supplier-info/supplier-job-screen-supplier-info.component';
import { SupplierJobScreenAdditionalCostsComponent } from './supplier/supplier-job-screen-additional-costs/supplier-job-screen-additional-costs.component';
import { DeclineAdditionalChargeComponent } from '../job-control/decline-additional-charge/decline-additional-charge.component';
import { RequestAdditionalInfoComponent } from '../job-control/request-additional-info/request-additional-info.component';
import { RouteRecommendationDetailedViewComponent } from '../route-recommendations/route-recommendation-detailed-view/route-recommendation-detailed-view.component';
import { JobScreenRouteDetailsComponent } from './route-details/route-details.component';
import { GrabBonusBadgeComponent } from '../route-recommendations/grab-bonus-badge/grab-bonus-badge.component';
import { RouteJobScreenRouteTasksComponent } from './route-details/route-job-screen-route-tasks/route-job-screen-route-tasks.component';
import { NgOptimizedImage } from '@angular/common';
import { RouteJobScreenTaskTimesComponent } from './route-details/route-job-screen-task-times/route-job-screen-task-times.component';
import { RouteItineraryConfirmationPopupComponent } from '../route-recommendations/route-itinerary/popups/route-itinerary-confirmation-popup/route-itinerary-confirmation-popup.component';
import { RouteJobScreenTasksComponent } from './route-details/route-job-screen-tasks/route-job-screen-tasks.component';
import { JobScreenCustomerTaskWindowComponent } from './common/job-screen-customer-task-window/job-screen-customer-task-window.component';
import { RouteIconComponent } from '../route-recommendations/route-itinerary/components/route-icon/route-icon.component';
import { RouteTagComponent } from '../route-recommendations/route-itinerary/components/route-tag/route-tag.component';
import { JobScreenVehicleCleanlinessComponent } from './common/job-screen-vehicle-cleanliness/job-screen-vehicle-cleanliness.component';
import { AdditionalInternalRequestComponent } from '../job-control/additional-internal-request/additional-internal-request.component';
import { ChangeAssigneeComponent } from '../job-control/change-assignee/change-assignee.component';
import { ChangeExpenseStatusComponent } from '../job-control/change-additional-status/change-expense-status.component';
import { QueueAutoDirectButtonComponent } from '../auto-direct/queue-auto-direct-button.component';
const routes: Routes = [
  { path: '', component: JobScreenContainerComponent, data: { title: 'Job Screen' } },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    ButtonModule,
    EditContactDetailsDialogComponent,
    DialogModule,
  ],
  exports: [RouterModule],
  declarations: [],
})
export class JobScreenContainerRoutingModule {}

@NgModule({
  imports: [
    JobScreenContainerRoutingModule,
    JobScreenModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    PostcodeMapsModule,
    AutoCompleteModule,
    ChecklistCategoryItemModule,
    VmeAdditionalCostsComponent,
    EditTaskWindowsDialogComponent,
    What3wordsComponent,
    VmeEditOrderDialogComponent,
    EditContactDetailsDialogComponent,
    JobScreenCarryOverComponent,
    TaskSequencingEditorComponent,
    DeclineAdditionalChargeComponent,
    ChangeAssigneeComponent,
    ChangeExpenseStatusComponent,
    RequestAdditionalInfoComponent,
    RouteRecommendationDetailedViewComponent,
    NgOptimizedImage,
    RouteItineraryConfirmationPopupComponent,
    RouteIconComponent,
    RouteTagComponent,
    AdditionalInternalRequestComponent,
    QueueAutoDirectButtonComponent,
    JobScreenVehicleCleanlinessComponent,
    GrabBonusBadgeComponent,
  ],
  declarations: [
    CustomerJobScreenComponent,
    JobScreenContainerComponent,
    JobScreenDriverPerformanceComponent,
    JobScreenOrdersComponent,
    JobScreenChecklistComponent,
    JobScreenHistoryComponent,
    JobScreenTasksComponent,
    JobScreenReleaseCodeComponent,
    JobScreenModelPinComponent,
    JobScreenDriverDetailsComponent,
    JobScreenDriverNotesComponent,
    JobScreenSiteOpeningComponent,
    JobScreenOrderTasksComponent,
    JobScreenContactPeopleComponent,
    JobScreenImageGalleryComponent,
    JobScreenVehicleInformationComponent,
    JobScreenDriverMessagesComponent,
    JobScreenFuelLevelsComponent,
    JobScreenLateStatusComponent,
    JobScreenOdometerReadingsComponent,
    JobScreenDelayFailuresDialogComponent,
    JobScreenEditVehicleDialog,
    SupplierJobScreenComponent,
    VmeChangeJobDetailsDialogComponent,
    TabScrollerComponent,
    VMEJobScreenComponent,
    VMEJobScreenIncidentsComponent,
    VMEJobScreenDatesPricesComponent,
    VMEJobScreenSupplierInfoComponent,
    VMEJobScreenRecognitionComponent,
    VMEJobScreenTasksServiceTypeComponent,
    VmeCancelOrderDialogComponent,
    JobScreenInspectionContactsComponent,
    JobScreenInspectionHandoverComponent,
    SupplierJobScreenTasksComponent,
    SupplierJobScreenRejectJobComponent,
    SupplierJobScreenSupplierInfoComponent,
    SupplierJobScreenAdditionalCostsComponent,
    JobScreenRouteDetailsComponent,
    RouteJobScreenRouteTasksComponent,
    RouteJobScreenTaskTimesComponent,
    RouteJobScreenTasksComponent,
    JobScreenCustomerTaskWindowComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobScreenContainerModule {}
